import { useState } from 'react';
import { createPortal } from 'react-dom';
import { ActionButton } from '@/shared/ui/ActionButton/ActionButton';
import { Modal } from '@/shared/ui/Modal/Modal';
import type { MediaAssetResponse } from '@/core/generated/api';
import { MediaLibraryBrowser } from './MediaLibraryBrowser';
import classes from './MediaLibrary.module.scss';

interface MediaPickerButtonProps {
    onPick: (url: string, asset: MediaAssetResponse) => void;
    disabled?: boolean;
}

/** Выбирает опубликованное изображение медиатеки с его метаданными */
export const MediaPickerButton = ({ onPick, disabled }: MediaPickerButtonProps) => {
    const [visible, setVisible] = useState(false);

    return <>
        <ActionButton
            type="button"
            icon="pi pi-images"
            outlined
            color="secondary"
            permission="admin.media-library.view"
            disabled={disabled}
            onClick={() => setVisible(true)}
        >
            Выбрать из медиатеки
        </ActionButton>
        {visible && createPortal(
            <Modal
                appearance="surface"
                visible
                title="Выбрать изображение"
                draggable
                size="xl"
                className={classes.pickerModal}
                onHide={() => setVisible(false)}
            >
                <MediaLibraryBrowser
                    onCancel={() => setVisible(false)}
                    onPick={asset => {
                        if (asset.url) {
                            onPick(asset.url, asset);
                            setVisible(false);
                        }
                    }}
                />
            </Modal>,
            document.body,
        )}
    </>;
};
